const bar = 'animate-pulse rounded-md bg-black/10';

function Bar({ className = '' }: { className?: string }) {
  return <div className={`${bar} ${className}`} />;
}

/**
 * Loading placeholder for a single "Nearby X" strip. Reserves the same
 * heading + 4-card grid as the real content so nothing reflows once
 * data arrives.
 */
export function NearbyStripSkeleton({ count = 4 }: { count?: number } = {}) {
  return (
    <section className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Bar className="h-6 w-[45%] max-w-[420px]" />
        <Bar className="h-9 w-24 rounded-full" />
      </div>
      <div className="row g-3">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0 mb-md-3">
            <div className="rounded-xl border border-black/5 bg-white p-3">
              <Bar className="h-4 w-20" />
              <Bar className="mt-3 h-6 w-[85%]" />
              <div className="mt-3 flex items-center gap-2">
                <Bar className="h-4 w-4" />
                <Bar className="h-4 w-[55%]" />
              </div>
              <div className="mt-2 flex items-center gap-2">
                <Bar className="h-4 w-4" />
                <Bar className="h-4 w-[40%]" />
              </div>
              <div className="mt-2 flex items-center gap-2">
                <Bar className="h-4 w-4" />
                <Bar className="h-4 w-[70%]" />
              </div>
              <Bar className="mt-4 h-5 w-[45%]" />
              <Bar className="mt-4 h-9 w-full rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
